import axios from 'axios';
import { useAuthStore } from '@store/auth';
import { useApiConfigStore } from '@store/api_config';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Update baseURL dynamically before each request
api.interceptors.request.use((config) => {
  const apiUrl = useApiConfigStore.getState().getApiUrl();
  config.baseURL = apiUrl;
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Add authentication token
api.interceptors.request.use(async (config) => {
  const user = useAuthStore.getState().user;
  if (user) {
    try {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      console.error("Failed to get Firebase token:", error);
    }
  }
  return config;
});

// Handle errors globally
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const originalRequest = error.config;

    // 1. Unauthorized — try a token force-refresh + one retry before logging out
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const user = useAuthStore.getState().user;
      if (user) {
        try {
          const freshToken = await user.getIdToken(true);
          originalRequest.headers.Authorization = `Bearer ${freshToken}`;
          return api(originalRequest);
        } catch {
          // Force-refresh failed → user is truly unauthorized
        }
      }
      await new Promise((r) => setTimeout(r, 2000));
      localStorage.clear();
      useAuthStore.getState().logout();
    }

    // 2. Validation errors (400)
    if (status === 400) {
      console.log("Bad request:", error.response.data);
    }

    // 3. Server errors (500)
    if (status >= 500) {
      console.log("Server error:", error.response.data);
    }

    return Promise.reject(error);
  }
);

export default api;
